/*global &*/
import { servicios } from "../properties";
import { callService, goTo } from "../tools";
import appTimer from "../app-timer";
import { database } from "../app-database";

export const validarEmail = (sParam) => {
	return fetch(servicios.validarEmail, {
		method: "post",
		body: JSON.stringify({
			usuario: sParam,
		})
	});
};

export const validarPass = (mail, password) => {
	console.log(mail);
	// console.log(password);
	return fetch(servicios.validarPass + "?mail=" + mail + "&password=" + password);
};

export const verificarPregunta = (sParam) => {
	return fetch(servicios.verificarPregunta, {
		method: "post",
		body: JSON.stringify({
			p: sParam.p,
			r: sParam.r
		})
	});
};

export const getNombre = (correo) => {
	return dispatch => {
		dispatch({ "type": "LOGIN_SET_ERROR", 
					 "error" : false,
					 "mensaje": ""
				  });
		dispatch({ "type": "LOADER_SHOW"});
		let llamadaSeguro = new callService({
			service: "login.nombre",
			"secure": true,
			data: { correo : correo}
		}).execute().then(body=>{
			dispatch({ "type": "LOADER_HIDE"});
			if(body.hasOwnProperty("error")){
				  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Tuvimos un error" 
				  });
			  }
			  else {
				  console.log(body);
				  //Usuario correcto
				  if(body.hasOwnProperty("name")){
					  dispatch({"type": "LOGIN_SET_SECRETO", "secreto": body.name});
					  dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
				  }
				  //Usuario bloqueado
				  /*else if(body.hasOwnProperty('uid') && body.uid == 0){
					  dispatch({ "type": "LOADER_HIDE"});
					  dispatch({ "type": "OLVIDE_SET_PASO", "paso": "bloqueado"});
					  goTo("olvide");
				  }*/
				  //Usuario migrado
				  else if(body.hasOwnProperty("uid") && body.hasOwnProperty("estatus")){
					 let url = body.uid + "/" + body.time + "/" + body.estatus;
					 dispatch({ "type": "LOGIN_RESET_PASO" });
					 dispatch({ "type": "OLVIDE_SET_URL", "url": body.uid + "/" + body.time + "/" + body.estatus});
					 dispatch({ "type": "OLVIDE_SET_CORREO", "correo": correo});
					 goTo("olvide");
					 //window.location.href = '/#!/olvide';
					 
					 let llamadaSeguro = new callService({
						service: "olvideContrasena.enviarCorreo",
						"secure": true,
						data: { correo: correo, url: url}
					}).execute().then(body=>{
						dispatch({ "type": "LOADER_HIDE"});
						if(body.hasOwnProperty("error")){
							  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
								  "titulo": "Error", 
								  "mensaje" : "Tuvimos un error" 
							  });
						  }
						  else {
							 console.log(body);
							 if(body.correlationId != "" )
							 {
								 dispatch({ "type": "OLVIDE_PASO_SIGUIENTE" });
							 }
							 else {
								 dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
									  "titulo": "Error", 
									  "mensaje" : "Hubo un error al mandar el correo. Favor de intentar más tarde." 
								  });
							 }
							 
						  }
					}).catch(error => {
						dispatch({ "type": "LOADER_HIDE"});
						console.log(error);
						
						dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
							  "titulo": "Error", 
							  "mensaje" : "Hubo un error al mandar el correo. Favor de intentar más tarde." 
						  });
					}); 
				  }
				  
			  }
		}).catch(error => {
			console.log(error);
			dispatch({ "type": "LOADER_HIDE"});
			if(error.body.hasOwnProperty("error")) {
				dispatch({
					"type": "LOGIN_SET_ERROR",
					"error": true,
					"mensaje": "Lo sentimos, el correo electrónico proporcionado no está registrado."
				});
				dispatch({ "type": "EVENT_LOGIN_INICIARSESION-INCORRECTOS", "flujo": "login", "dispositivo": dispositivo });
			} else {
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al obtener el nombre. Favor de intentar más tarde." 
				  });
			}
		});
	};
};

export const cargarPreguntas = (correo) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW"});
		let llamadaSeguro = new callService({
			service: "login.obtenerPreguntas",
			"secure": true,
			data: {	correo: correo}
		}).execute().then(body=>{
			// Catalogo de preguntas secretas
			database.ref("preguntas").on("value", snapshot => {
				let data = snapshot.val();
				dispatch({
					"type": "CARGAR_CATALOGO_PREGUNTAS",
					"catalogoPregunta1": data.pregunta1,
					"catalogoPregunta2": data.pregunta2
				});
			});
			
			if(body.hasOwnProperty("error")){
				  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Tuvimos un error" 
				  });
			  }
			  else {
				console.log(body);
				dispatch({
					"type": "LOGIN_SET_PREGUNTAS",
					"p1": body.p1,
					"p2": body.p2,
				});
				dispatch({
					"type": "LOGIN_SET_UID",
					"uid": body.uid,
				});
			  }
			  dispatch({ "type": "LOADER_HIDE"});
		}).catch(error => {
			dispatch({ "type": "LOADER_HIDE"});
			console.log(error);
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al obtener las preguntas. Favor de intentar más tarde." 
				  });
		});
	};
};

export const desbloquearUsuario = (datos) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW"});
		console.log(datos);
		
		let llamadaSeguro = new callService({
			service: "login.validarPreguntas",
			"secure": true,
			data: datos
		}).execute().then(body=>{
			/* dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", 
					  "load": false
				  });*/
			if(body.hasOwnProperty("error")){
				  dispatch({ "type": "LOADER_HIDE"});
				  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al validar las preguntas. Favor de intentar más tarde." 
				  });
			  }
			  else {
				  console.log(body);
				  dispatch({ "type": "LOADER_HIDE"});
				  if( body.hasOwnProperty("validacionPreguntasSeguridadResponse") && body.validacionPreguntasSeguridadResponse.return=="SUCCEEDED")
				  {
					  dispatch(enviarEmail(datos.correo));
				  }
				  else if( body.hasOwnProperty("suspederUsuarioResponse") && body.suspederUsuarioResponse.return=="SUCCEEDED")
				  {
					 dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
				  }
				  else{
					  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al validar las preguntas. Favor de intentar más tarde." 
						});
				  }
			  }
		}).catch(error => {
			dispatch({ "type": "LOADER_HIDE"});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al validar las preguntas. Favor de intentar más tarde." 
						});
			/*
			if(error.message.detail.eotException.mensajeTecnico != "")
			{
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error: " + error.message.detail.eotException.codigoError, 
					  "mensaje" : error.message.detail.eotException.mensajeTecnico
				  });
			}*/
		});
	};
};

export const enviarEmail = (correo) => {
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW"});
		let llamadaSeguro = new callService({
			service: "olvideContrasena.consultarUsuario",
			"secure": true,
			data: { correo: correo}
		}).execute().then(body=>{
			if(body.hasOwnProperty("error")){
				  dispatch({ "type": "LOADER_HIDE"});
				  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Tuvimos un error" 
				  });
			  }
			  else {
				 console.log(body);
				 if(body.uid == 0)
				 {
					 dispatch({ "type": "LOADER_HIDE"});
					 dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error. Inténtelo más tarde." 
					 });
				 }
				 else{
					 let url = body.uid + "/" + body.time + "/" + body.estatus;
					 
					 let llamadaSeguro = new callService({
						service: "olvideContrasena.enviarCorreo",
						"secure": true,
						data: { correo: correo, url: url}
					}).execute().then(body=>{
						dispatch({ "type": "LOADER_HIDE"});
						if(body.hasOwnProperty("error")){
							  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
								  "titulo": "Error", 
								  "mensaje" : "Hubo un error. Inténtelo más tarde." 
							  });
						  }
						  else {
							 console.log(body);
							 if( body.hasOwnProperty("correlationId") && body.correlationId != "" )
							 {
								 $("#modal-correcto").modal("toggle");
							 }
							 else {
								 console.log("hubo un error");
								  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
								  "titulo": "Error", 
								  "mensaje" : "Hubo un error. Inténtelo más tarde." 
								 });
							 }
						  }
					}).catch(error => {
						dispatch({ "type": "LOADER_HIDE"});
						console.log(error);
						
						dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
							  "titulo": "Error", 
							  "mensaje" : "Hubo un error al mandar el correo. Favor de intentar más tarde." 
						  });
					}); 
				 }
			  }
		}).catch(error => {
			dispatch({ "type": "LOADER_HIDE"});
			console.log(error);
			
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al mandar el correo. Favor de intentar más tarde." 
				  });
			
			
		});
	};
};


// WEBPACK FOOTER //
// ./src/login/services.act.js